import React from 'react';

import './fullview.scss';
import { Box, Stack } from '@mui/material';
import CollapsibleSidebar from '../../components/shared/Layouts/sidebar/CollapsibleSidebar';
import Header from '../../components/shared/Layouts/header/header';
import { ChevronRight } from '@mui/icons-material';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { METADATA_KEY } from '../../utils/utils';


const containerStyle = {
  display: 'grid',
  gridTemplateColumns: '200px auto',
  minHeight: '100vh',
  width: '100%',
  height: '100%',
  zoom: '80%'
};

const Style1 = {
  height: '100%',
  padding: 0,
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
  flexGrow: 1
};

// const OVERVIEW_CONTENT_BACKGROUND =
//   'radial-gradient(900px 480px at 8% -6%, rgba(255,45,77,.10), transparent 55%), radial-gradient(760px 460px at 98% 2%, rgba(91,157,255,.08), transparent 55%), radial-gradient(700px 500px at 60% 120%, rgba(167,139,250,.06), transparent 60%), #0f1522';
// const OVERVIEW_CONTENT_BACKGROUND = '#0f1522';
const OVERVIEW_CONTENT_BACKGROUND = '#1f2535';
const isOverviewPath = (pathname = '') =>
  pathname === '/' || pathname === '/overview';

const readShowNewOverview = () => {
  try {
    const meta = JSON.parse(localStorage.getItem(METADATA_KEY) || '{}');
    return !!meta?.ui_show_new_overview;
  } catch {
    return false;
  }
};

class FullView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      localDrawerState: false,
      showNewOverview: readShowNewOverview(),
    };
    this.sidebarRef = React.createRef();
  }

  clickOutside(e) {
    document.getElementById('header').click();
  }
  componentDidMount() {
    const drawerState = window.localStorage.getItem('drawerState');
    this.setState({
      open: JSON.parse(drawerState),
      localDrawerState: JSON.parse(drawerState),
      showNewOverview: readShowNewOverview(),
    });
    window.addEventListener('metadata_loaded', this.handleMetadataLoaded);
  }

  componentWillUnmount() {
    window.removeEventListener('metadata_loaded', this.handleMetadataLoaded);
  }

  handleMetadataLoaded = () => {
    this.setState({ showNewOverview: readShowNewOverview() });
  };

  handleToggleDrawer = () => {
    this.setState((prevState) => {
      window.localStorage.setItem(
        'drawerState',
        JSON.stringify(!prevState.open)
      );
      return {
        open: !prevState.open,
        localDrawerState: !prevState.open
      };
    });
  };

  handleMouseEnter = () => {
    this.setState({ open: true });
  };

  handleMouseLeave = () => {
    if (!this.state.localDrawerState) {
      this.setState({ open: false });
    }
  };
  render() {
    const { open, showNewOverview } = this.state;
    const sidebarWidth = open ? '300px' : '80px';
    const pathname = this.props.location?.pathname ?? '';
    const overviewBackground = isOverviewPath(pathname)
      ? { background: OVERVIEW_CONTENT_BACKGROUND }
      : {};

    return (
      <>
        <div
          className='App'
          style={Style1}
        >
          <div
            className='container-fluid'
            style={Style1}
          >
            <Stack
              sx={{ position: 'relative' }}
              direction={'row'}
              className='page-container'
            >
              <div
                style={{ position: 'relative' }}
                ref={this.sidebarRef}
              >
                <CollapsibleSidebar
                  open={open}
                  onMouseEnter={this.handleMouseEnter}
                  mouseLeave={this.handleMouseLeave}
                  showSidebarUserHeader={showNewOverview}
                />
              </div>
              <div
                className='col content'
                style={{
                  marginLeft: sidebarWidth,
                  ...(showNewOverview ? { paddingTop: '62px' } : {}),
                  transition: 'margin-left 0.3s ease-in-out',
                  ...overviewBackground,
                }}
              >
                <Box
                  style={{
                    left: sidebarWidth
                  }}
                  className='sidebar-expand-btn'
                  onClick={this.handleToggleDrawer}
                >
                  <ChevronRight
                    style={{
                      fontSize: '30px',
                      transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                      transition: 'all 0.3s ease-in-out',
                      color: '#c3c7dc'
                    }}
                  />
                </Box>
                {this.props.showTooltip && (
                  <div
                    style={{
                      position: 'fixed',
                      top: 0,
                      left: 0,
                      padding: '4px 8px',
                      backgroundColor: '#000',
                      color: '#fff',
                      borderRadius: '6px',
                      fontSize: '14px',
                      whiteSpace: 'nowrap',
                      pointerEvents: 'none',
                      zIndex: 9999,
                      transform: `translate(${this.props.tooltipCoords.x / 0.8}px, ${this.props.tooltipCoords.y / 0.8 - 45}px)`,
                    }}
                  >
                    {this.props.tooltipText}
                  </div>
                )}
                {!showNewOverview && <Header placement="top" />}
                {this.props.children}
              </div>
            </Stack>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  showTooltip: state.common.showTooltip,
  tooltipText: state.common.tooltipText,
  tooltipCoords: state.common.tooltipCoords,
});

export default withRouter(connect(mapStateToProps)(FullView));
